import LeaveEvent from '@/components/requests/leave/events/LeaveEvent'

export default class CommentDeletedEvent extends LeaveEvent {
  asText(viewer) {
    return `**${this.getActorName(viewer)}** deleted a comment`
  }
}
